import { Button, Input, Modal, Form } from "antd";
import "./CreateAccModal.css";
import UserService from "../../../Services/user.service";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { persistor } from "../../../Redux/configureStore";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";

function CreateAccModal({ openModal, setCreateAccModal }) {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [allValidated, setAllValidated] = useState(false);
  const [tempData, setTempData] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const validate = async () => {
      try {
        await form.validateFields();
        setAllValidated(true);
      } catch (err) {
        console.log(err);
      }
    };
    validate();
  }, [openModal, tempData, form]);

  async function waitRehydrate() {
    if (persistor.getState().rehydrated) return;
    await new Promise((resolve) =>
      persistor.subscribe(() => {
        if (persistor.getState().rehydrated) resolve();
      })
    );
  }

  // const handleSubmit = async (values) => {
  //   try {
  //     if (openModal === "signIn") {
  //       const res = await UserService.logIn(values.email, values.password);
  //       if (res?.success === true) {
  //         toast.success(res?.message);

  //         const userInfo = {
  //           email: res?.data?.user?.email,
  //           id: res?.data?.user?.id,
  //           role: res?.data?.user?.role,
  //           username: res?.data?.user?.username,
  //           avatar: res?.data?.user?.avatar,
  //           bio: res?.data?.user?.bio,
  //         };
  //         localStorage.setItem("userInfo", JSON.stringify(userInfo));
  //         localStorage.setItem("accessToken", res?.data?.accessToken);
  //         localStorage.setItem("refreshToken", res?.data?.refreshToken);
  //         handleCloseModal();
  //         navigate("/");
  //       } else {
  //         toast.error(res?.message);
  //       }
  //     } else if (openModal === "createAcc") {
  //       if (allValidated) {
  //         setLoading(true);
  //         const data = form.getFieldsValue();

  //         // xem thử dữ liệu nhập vào
  //         console.log("data: ", data);

  //         try {
  //           const res = await axios.post(
  //             process.env.REACT_APP_SERVER_URL + "/user/createAcc",
  //             data
  //           );
  //           if (res.status === 201) {
  //             toast.success("Tạo tài khoản thành công");
  //             handleNavigateLogin();
  //           }
  //         } catch (err) {
  //           console.error("Upload error: ", err);
  //           toast.error("Đăng tải thất bại");
  //         } finally {
  //           setLoading(false); // Turn off loading once API response is received
  //         }
  //       }
  //     } else {
  //       handleCloseModal();
  //     }
  //   } catch (error) {
  //     console.log(error.message);
  //   }
  // };

  // For demployment
  const handleSubmit = async (values) => {
    try {
      setLoading(true); // Start loading
      console.log("Data g?i di: ", values);
      console.log("server url take from .env at client: ", process.env.REACT_APP_SERVER_URL);

      if (openModal === "createAcc") {
        // Handle Signup
        const { password, passwordConfirm } = values;

        // Check if passwords match
        if (password !== passwordConfirm) {
          toast.error("Mật khẩu xác nhận không khớp");
          return;
        }

        // Call the signup API using Axios
        const response = await axios.post(
          process.env.REACT_APP_SERVER_URL + "/user/signup",
          values
        );

        if (response.data) {
          toast.success("Đăng ký thành công!");
          handleNavigateLogin(); // Switch to login modal
        }
      } else if (openModal === "signIn") {
        // Handle Login
        const { email, password } = values;

        // Call the login API using Axios
        const response = await axios.post(
          process.env.REACT_APP_SERVER_URL + "/user/login",
          { email, password },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        console.log(response.data);
        console.log(response.data?.user);


        if (response.data?.user) {
          localStorage.setItem("userInfo", JSON.stringify(response.data.user));
          toast.success("Đăng nhập thành công!");
          handleCloseModal();
          await waitRehydrate();
          navigate("/home");
        }
      }
    } catch (error) {
      console.log(error.message);
      toast.error("Đã xảy ra lỗi. Vui lòng thử lại.");
    } finally {
      setLoading(false); // Stop loading
    }
  };

  const handleNavigateLogin = () => {
    form.resetFields();
    setTempData({});
    setAllValidated(false);
    setCreateAccModal("signIn");
  };

  const handleCloseModal = () => {
    form.resetFields();
    setTempData({});
    setAllValidated(false);
    setCreateAccModal(null);
  };

  return (
    <Modal
      open={openModal === "signIn" || openModal === "createAcc"}
      onCancel={handleCloseModal}
      footer={null}
      width={400}
    >
      <div className="createAccContainer">
        <Button
          className="createAccBtn googleBtn"
          variant="outlined"
          // onClick={async () => {
          //   await UserService.googleLogin();
          // }}
          disabled={true}
        >
          <img
            style={{ width: "20px", height: "20px" }}
            src="/googleLogo.png"
            alt=""
          />
          <span>Tiếp tục với Google</span>
        </Button>

        <p>Hoặc</p>
        <Form
          form={form}
          initialValues={{
            remember: true,
          }}
          onFinish={handleSubmit}
          onValuesChange={(_, values) => setTempData(values)}

          //   onFinish={onFinish}
          //   onFinishFailed={onFinishFailed}
          //   autoComplete="off"
        >
          {openModal === "createAcc" && (
            <Form.Item
              name="username"
              rules={[
                {
                  required: true,
                  message: "Thông tin không được để trống",
                },
              ]}
            >
              <Input placeholder="Nhập Username" className="createAccBtn" />
            </Form.Item>
          )}
          <Form.Item
            name="email"
            rules={[
              {
                required: true,
                message: "Thông tin không được để trống",
              },
            ]}
          >
            <Input placeholder="Nhập Email" className="createAccBtn" />
          </Form.Item>
          <Form.Item
            name="password"
            rules={[
              {
                required: true,
                message: "Thông tin không được để trống",
              },
              ...(openModal === "createAcc"
                ? [
                    {
                      validator: (_, value) => {
                        const passwordRegex =
                          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#^])[A-Za-z\d@$!%*?&#^]{8,}$/;
                        if (!value || passwordRegex.test(value)) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          "Mật khẩu phải chứa ít nhất 8 ký tự, bao gồm 1 chữ thường, 1 chữ hoa, 1 số và 1 ký tự đặc biệt"
                        );
                      },
                    },
                  ]
                : []),
            ]}
          >
            <Input.Password
              placeholder="Nhập mật khẩu"
              className="createAccBtn"
            />
          </Form.Item>
          {openModal === "createAcc" && (
            <Form.Item
              name="passwordConfirm"
              rules={[
                {
                  required: true,
                  message: "Thông tin không được để trống",
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("password") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject("Mật khẩu xác nhận không khớp");
                  },
                }),
              ]}
            >
              <Input.Password
                placeholder="Xác nhận mật khẩu"
                className="createAccBtn"
              />
            </Form.Item>
          )}
          <Form.Item label={null}>
            <Button
              className="createAccBtn"
              type="primary"
              htmlType="submit"
              disabled={!allValidated || loading}
            >
              Tiếp tục
            </Button>
          </Form.Item>
        </Form>
      </div>
    </Modal>
  );
}

export default CreateAccModal;
